import {
  KEY_TYPE, OptionType, SearchOptionsType,
} from 'pages/mailMagazine/type';
import { SEARCH_TYPE } from 'pages/customer/advancedSearch/options';
import reducer from './reducer';
import * as MailMagazineAction from './action';

export interface MailMagazineCreateEditType {
    // mailMagazineSearchCondition:IMailMagazineSearchCondition | null
subject:string | null
body:string | null
signature:string | null
sendFlag:boolean
mailMagazineSendCustomer:string[]
sendCount:number| null
// loading:boolean,
valueMenuItemOptionsState: Map<KEY_TYPE, OptionType[]>,
isComeFromHistory:boolean,
conditionType:SEARCH_TYPE,
error:null | string,
searchConditionList:SearchOptionsType[],
mailMagazineId:string,
isReloadHistory:boolean,
isInitData:boolean,
senderOrgId:string,
senderOrgName?:string,
senderOrgAddress?:string,
}

export {
  MailMagazineAction,
};

export default reducer;
